import { __assign } from "tslib";
import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function SwatchBg(props) {
    return (React.createElement(Svg, __assign({ display: "block", height: "24", viewBox: "0 0 24 24", width: "24" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("g", { fill: "#edeeef" },
                React.createElement("path", { d: "m0 0h8v8h-8z" }),
                React.createElement("path", { d: "m0 16h8v8h-8z" }),
                React.createElement("path", { d: "m16 0h8v8h-8z" }),
                React.createElement("path", { d: "m16 16h8v8h-8z" })),
            React.createElement("path", { d: "m8 0h8v8h-8z", fill: "#fff" }),
            React.createElement("path", { d: "m8 16h8v8h-8z", fill: "#fff" }),
            React.createElement("path", { d: "m8 8h8v8h-8z", fill: "#edeeef" }),
            React.createElement("path", { d: "m0 8h8v8h-8z", fill: "#fff" }),
            React.createElement("path", { d: "m16 8h8v8h-8z", fill: "#fff" }))));
}
